import { Sparkles } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";

export default function Invoice({ booking }) {
  const { t, lang, L, settings } = useApp();
  if (!booking) return null;
  const c = booking.customer || {};
  const brand = settings ? L(settings, "brand_name") : t.brand;
  const payLabel = t.payment[booking.payment_status] || booking.payment_status;

  return (
    <div className="rounded-3xl bg-card cb-card-shadow p-6 sm:p-8" data-testid="invoice">
      <div className="flex items-center justify-between border-b border-border pb-5">
        <div className="flex items-center gap-2">
          <span className="grid place-items-center h-10 w-10 rounded-full cb-gradient text-primary-foreground">
            <Sparkles className="h-5 w-5" />
          </span>
          <div>
            <div className="font-display text-2xl font-bold">{brand}</div>
            <div className="text-xs text-muted-foreground">{lang === "ar" ? "فاتورة حجز" : "Booking Invoice"}</div>
          </div>
        </div>
        <div className="text-end">
          <div className="text-xs text-muted-foreground">{t.booking.reference}</div>
          <div className="font-bold text-primary" dir="ltr">{booking.reference}</div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 py-5 text-sm">
        <div><span className="text-muted-foreground">{t.booking.fullName}: </span><b>{c.name}</b></div>
        <div><span className="text-muted-foreground">{t.booking.phone}: </span><b dir="ltr">{c.phone}</b></div>
        <div><span className="text-muted-foreground">{t.booking.chooseDate}: </span><b>{booking.date}</b></div>
        <div><span className="text-muted-foreground">{t.booking.chooseTime}: </span><b dir="ltr">{booking.time}</b></div>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="text-muted-foreground border-b border-border">
            <th className="text-start py-2 font-medium">{t.nav.services}</th>
            <th className="text-end py-2 font-medium">{t.common.sar}</th>
          </tr>
        </thead>
        <tbody>
          {(booking.services || []).map((s, i) => (
            <tr key={i} className="border-b border-border/60">
              <td className="py-2">{L(s, "name")}</td>
              <td className="py-2 text-end font-medium">{s.price}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-4 space-y-1 text-sm">
        <div className="flex justify-between"><span className="text-muted-foreground">{t.booking.subtotal}</span><span>{booking.subtotal} {t.common.sar}</span></div>
        {booking.discount > 0 && (
          <div className="flex justify-between text-destructive"><span>{t.booking.discount}</span><span>- {booking.discount} {t.common.sar}</span></div>
        )}
        <div className="flex justify-between text-lg font-bold pt-2 border-t border-border mt-2">
          <span>{t.booking.total}</span><span className="text-primary">{booking.total} {t.common.sar}</span>
        </div>
        <div className="flex justify-between pt-2">
          <span className="text-muted-foreground">{t.my.status}</span>
          <span className="font-semibold">{payLabel}</span>
        </div>
      </div>

      <Button onClick={() => window.print()} variant="outline" className="mt-6 rounded-full w-full border-2 no-print font-semibold" data-testid="print-invoice-btn">
        {t.common.print}
      </Button>
    </div>
  );
}
